export function useTrailingSlash(url?: string | null) {
  const config = useRuntimeConfig()
  const trailingSlash = config.public.trailingSlash
  if (!url) return trailingSlash ? '/' : ''
  if (trailingSlash) {
    if (url.endsWith('/')) return url
    return `${url}/`
  }
  else {
    if (url.endsWith('/')) return url.replace(/\/+$/, '')
    return url
  }
}

export function useRemoveTrailingSlash(url?: string | null) {
  if (!url) return ''
  if (url.endsWith('/')) return url.replace(/\/+$/, '')
  return url
}
